import magnifyingGlass from "./magnifyingGlass.svg";
import mapPin from "./mapPin.svg";
import mapWithPin from "./mapWithPin.svg";

export { magnifyingGlass, mapPin, mapWithPin };
